import React from "react";
import { Box } from "@mui/material";

import PreChatHeader from "../ui/PreChatHeader";
import PreChatContainer from "../ui/PreChatContainer";
import Column from "../ui/core/Column";
import ChatInput from "../chat/components/ChatInput";
import { channelsConfig } from "../../config/channels";
import AppealsIcon from "../icons/AppealsIcon";

const AppealReview: React.FC = () => {
  return (
    <main className="grow flex flex-row bg-hex-gray-100 h-[calc(100%-6rem)]">
      <Column
        sx={{
          height: "100%",
          width: "100%",
          minWidth: 0,
          minHeight: 0,
          overflow: "hidden",
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            pt: { xs: 1.5, sm: 2 },
            pb: { xs: 1, sm: 1.5 },
            boxSizing: "border-box",
          }}
        >
          <PreChatContainer containerClassName="min-w-0">
            <PreChatHeader
              icon={<AppealsIcon size={28} />}
              iconAlt="Appeal Review"
              title="Appeal Review"
              description="Upload the claim, remit, payer correspondence and EMR to review your appeal for completeness and strength before submission."
            />
          </PreChatContainer>
        </Box>

        <ChatInput
          requiredInputs={channelsConfig["appeal-review"].requiredInputs}
        />
      </Column>
    </main>
  );
};

export default AppealReview;
